// extracted by mini-css-extract-plugin
export default {"usefulQuestions":"POIhF _38YTw"};